<div class="form-group search-group">
  <div class="search-group__search-icon">
    <mat-icon svgIcon="magnify"></mat-icon>
  </div>

  <input
    class="form-control"
    id="topSearchInput"
    [formControl]="search"
    type="search"
    placeholder="{{ 'What are you looking for?' | translate | async }}"
    (click)="!isAutocompleteOpened ? toggleAutocomplete() : null"
  />

  @if (search.value!.length > 0) {
    <mat-icon (click)="clear()" class="clear-icon"> close </mat-icon>
  }

  @if (
    {
      autocompleteResult: autocompleteResult$ | async,
      categories: categories$ | async,
      products: products$ | async,
      searchTerms: searchTerms$ | async,
      singleProduct: singleProduct$ | async,
      isSearchByExactMatch: isSearchByExactMatch$ | async,
    };
    as data
  ) {
    @if (isAutocompleteOpened && data.autocompleteResult !== null) {
      @if (
        (data.products && !data.products.length) ||
        (data.products && data.products.length === 1) ||
        (data.products && data.products.length === 1 && data.isSearchByExactMatch) ||
        (data.products && data.products.length > 1 && data.isSearchByExactMatch)
      ) {
        <div class="search-autocomplete single-view">
          <div class="search-autocomplete__left">
            <app-autocomplete-products-list
              [isSingleView]="true"
              [products]="data.products && data.products.length > 0 ? data.products : []"
              (toggleAutocomplete)="toggleAutocomplete()"
              (hoverProductItem)="hoverProductItem($event)"
            ></app-autocomplete-products-list>
          </div>
          <div class="search-autocomplete__right">
            @if (data.singleProduct) {
              <app-autocomplete-product-single
                [product]="data.singleProduct"
                (toggleAutocomplete)="toggleAutocomplete()"
              ></app-autocomplete-product-single>
            }
          </div>
        </div>
      } @else {
        @if (data.autocompleteResult && data.autocompleteResult !== null) {
          <div class="search-autocomplete">
            <div class="search-autocomplete__left">
              <app-autocomplete-terms
                [searchTerms]="data.searchTerms!"
              ></app-autocomplete-terms>
              <app-autocomplete-category
                [categories]="data.categories!"
                (toggleAutocomplete)="toggleAutocomplete()"
              ></app-autocomplete-category>
            </div>
            <div class="search-autocomplete__right">
              <app-autocomplete-products-list
                [products]="data.products!"
                (toggleAutocomplete)="toggleAutocomplete()"
              ></app-autocomplete-products-list>
              @if (data.products && data.products.length) {
                <a
                  (click)="toggleAutocomplete()"
                  [sRouterLink]="['search', search.value]"
                  class="look-closer"
                  >{{ 'Look closer' | translate | async }}</a
                >
              }
            </div>
          </div>
        }
      }
    }
    @if (isAutocompleteOpened && data.autocompleteResult !== null) {
      <div class="search-overlay" (click)="toggleAutocomplete()"></div>
    }
  }
</div>
